import { NetDriveDetailTable } from './net-drive-detail-table.js';

import type { RequirementInstanceResult } from '@cadstrom/sigma-engine-shared';
import type { GridRowModel } from '@mui/x-data-grid-premium';

type NetDriveDetailPanelProps = {
	row: GridRowModel<RequirementInstanceResult>;
	loading?: boolean;
	handleAddModuleFilter: (moduleReferenceDesignator: string) => void;
};

/**
 * Legacy detail-panel shim. Guards `row.instanceMetadata` to the NetDrive
 * shape and forwards to {@link NetDriveDetailTable}, which holds the actual
 * render so both V1 and V2 surfaces produce identical output.
 */
export function NetDriveDetailPanel({ row, loading = false, handleAddModuleFilter }: NetDriveDetailPanelProps) {
	const instanceMetadata = row.instanceMetadata?.type === 'NetDriveCompatibilityResult' ? row.instanceMetadata : null;
	if (!instanceMetadata) {
		return null;
	}
	return (
		<NetDriveDetailTable
			instanceMetadata={instanceMetadata}
			loading={loading}
			handleAddModuleFilter={handleAddModuleFilter}
		/>
	);
}
